<template>
		<div>
		<TopAppBar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="title"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
      :hideCategory="true"
			staticMode="true"
		>
		</TopAppBar>

		<div class="d-flex h-full flex-column">
				<TopAppBarDrawer></TopAppBarDrawer>
	<main class="main-wrapper flex-grow-1">
	<!-- <div class="t-headline11 t-color-headlineBlack pda-16 t-center font-m">전체 강의</div> -->
	<div class="container pdt-50">
		<div class="t-color-headlineBlack t-headline15 font-b">{{ this.$route.query.type && this.$route.query.type === "MICRO" ? $t('30235') : $t('3201') }}</div>
		<div class="divider mgt-24"></div>
	</div>
	 		<div class="container main-swiper-container main-swiper mgt-24 pdb-50">
					<div class="d-flex mgb-16 flex-wrap"  v-if="popularTag && popularTag.length">
						<template 	v-for="(tag, index) in popularTag">
									<div
									:key="index"
									v-if="firstSelectedTags.includes(tag.id)"
									class="pdl-8 pdr-12 mgr-8 mgt-4 t-body6 font-r t-color-contentBlue bg-contentBlueInactive h-32 t-center b-radius4 d-flex align-items-center">
													#{{tag.name}}
									</div>
									</template>
					</div>
					<div class="d-grid-3-24" v-if="learnOnlineData && learnOnlineData.content && learnOnlineData.content.length">
					<div 	v-for="(learnData, indexOnline) in learnOnlineData.content" :key="indexOnline+'_online'">
						<div class="mdc-card cursor-pointer" @click="redirectToCourseDetail(learnData.id)" @keypress="redirectToCourseDetail(learnData.id)" tabindex="0">
							<div class="mdc-card__primary-action1" tabindex="0">
								<div class=" position-relative" v-if="learnData.thumbnail">
									<img :src="learnData.thumbnail" v-if="learnData.thumbnail" alt="">
									<img src="/img/slider-placeholder.svg" v-else alt="">
									<div class="mdc-chip-set swiper-chip" role="grid">
										<div class="mdc-chip h-28 t-line-h-initial" role="row">
											<div class="mdc-chip__ripple"></div>
											<span role="gridcell">
												<span role="button" tabindex="0" class="mdc-chip__primary-action">
													<span class="mdc-chip__text t-body3 pdt-2 t-color-white">
														{{ $t("1908", { str: learnData.lessonCount }) }}
													</span>
												</span>
											</span>
										</div>
									</div>
								</div>
								<div class="mgt-24">
									<div class="t-headline7 pdl-24 pdr-24 font-m">
										{{ learnData.name ? learnData.name : "" }}
									</div>
								</div>
								<div class="mgt-16">
									<div class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r" v-if="!learnData.thumbnail">
										{{ $t("1908", { str: learnData.lessonCount }) }}
									</div>
									<div class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r" v-for="(level, index2) of learnData.levels" :key="index2">
										{{ level.text }}
									</div>
								</div>
								<div class="mgt-2 pdl-24 mgb-16">
									<span class="font-r t-color-headlineBlack t-body6 pdr-4">by </span>
									<span class="font-r t-color-headlineBlack t-body6">
										{{ learnData.teacher ? learnData.teacher.name.fullName : "" }}
									</span>
								</div>
									<div class="d-flex align-items-baseline pdl-24 pdb-24" v-if="learnData.goods && learnData.goods.paymentPrice > 0" >
											<div class="t-color-headlineBlack t-body-6 pdr-4" >{{ learnData.goods.currency.key || "USD" }}</div>
											<div class="t-color-headlineBlack t-headline10 pdr-8">{{ $n(learnData.goods.paymentPrice) }}</div>
											<div class="t-body1 t-color-bodyGrayB t-line-through-red" v-if="learnData.goods.paymentPrice < learnData.goods.price" >{{ $n(learnData.goods.price) }}</div>
									</div>
									<div class="d-flex align-items-baseline pdl-24 pdb-24" v-if="learnData.goods && ! learnData.goods.paymentPrice" >
										<div class="t-color-headlineBlack t-headline10 pdr-8">{{ $t("872") }}</div>
									</div>
							</div>
						</div>
					</div>
					</div>
				</div>
			</main>
		</div>
		</div>
</template>
<script>
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";

import { topAppBarMixin } from "../../mixins/topAppBar.js";
import mainApi from "@/api/mainApi.js";
import {mapState} from 'vuex'


export default {
	name: "TagSerachCourse",
	components: {
		TopAppBar,
		TopAppBarDrawer,
	},
	data() {
		return {
			popularTag : null,
   			learnOnlineData : null,
			firstSelectedTags:[],
		};
	},

	computed: {

	},

	mixins: [topAppBarMixin],
	mounted() {
		this.firstSelectedTags = this.$route.query.tags.split(",").map(Number);
  	// fetch all tags data
		mainApi.fetchPopularTag()
			.then((response) => {
				this.popularTag = response.data.data;
			})
			.catch((err) => { });
		let params = {size: 10, tags: this.$route.query.tags}
		const fetchLearn = this.$route.query.type && this.$route.query.type === "MICRO" ?
			mainApi.fetchPopularTagMicroLearn(params) : mainApi.fetchPopularTagLearn(params);
		fetchLearn
			.then((response) => {
					this.learnOnlineData = response.data.data;
			})
			.catch((err) => {
				responseData = err.response.data.meta;
				this.$error({ content: responseData.errMsg }).then(() => {});
			});
	},
	methods:{
		redirectToCourseDetail(id) {
			this.$router.push(
				this.$route.query.type && this.$route.query.type === "MICRO"
				? `/micro-course/${id}?type=ListNew`
				: `/degree/${id}?type=ListNew`
      		);
		},
	}
}
</script>
